module.exports = __webpack_public_path__ + "img/contacts.a05b48c7.svg";